module.exports = __webpack_public_path__ + "static/media/banner.cfab0718.png";